import React, { useRef } from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { Divider, IconButton, InputBase, InputLabel, Paper, Stack, Tooltip } from "@mui/material";
import CustomBackdrop from "../CustomBackdrop/Barckdrop";


const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}
export default function CustominputRang(props) {
    const { label, id, defaultValue, inputType, tabIndex, placeholder } = props
    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    const [state, setState] = React.useState({
        inputDataStart: "",
        inputDataEnd: "",
        sentData: false
    });
    React.useEffect(() => {
        console.log("defaultValue CustominputRang", defaultValue);
        if (state.sentData === false) {
            try {
                setState({
                    ...state,
                    ["sendData"]: false,
                    ["inputDataStart"]: defaultValue.docNoStart,
                    ["inputDataEnd"]: defaultValue.docNoEnd,

                });
            } catch (error) {
                console.log(error)

            }

        }
    }, [defaultValue])

    React.useEffect(() => {
        console.log("state.inputDataStart " + state.inputDataStart + 'state.inputDataEnd' + state.inputDataEnd);

        if (state.sentData === true) {
            props.resData({ docNoStart: state.inputDataStart, docNoEnd: state.inputDataEnd })
        }

        return () => {
        }
    }, [state])

    // React.useEffect(() => {
    //     if (inputDataStart === "" && inputDataEnd === "") {
    //         props.resData([inputDataStart, inputDataEnd])
    //     }
    //     return () => {
    //     }
    // }, [inputDataStart, inputDataEnd])

    const handleChange = (event, source) => {
        // event.preventDefault(); 
        // console.log("handleChange", event.target.value);
        if (source === "end") {

            setState({
                ...state
                , ["sentData"]: true,
                ["inputDataEnd"]: event.target.value,

            });
        } else {
            setState({
                ...state,
                ["sentData"]: true,
                ["inputDataStart"]: event.target.value,

            });
        }



    }
    const onBlur = (e, source) => {
        //  await setOpenBackdrop(true)

        // if (source === 'end') {
        //     setState({
        //         ...state,
        //         ["inputDataEnd"]: event.target.value,
        //     });
        // }


        // console.log("onBlur state", state)

        // await setOpenBackdrop(false)
    }
    const handleKeyDown = (event) => {
        //  console.log("handleKeyDown err", event.key);
        /// props.resData([inputDataStart, inputDataEnd])
        try {
            //if (event.key === "Enter") {
            props.keyDown(event.key)
        }
        catch (error) {
            console.log("handleKeyDown err", error);
        }
    }
    return (
        <Stack spacing={0} direction={{ base: 'row' }}  >
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '5px',
                    pt: '1px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",
                }}
            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "100px", whiteSpace: "nowrap",
                        fontSize: "16px",
                        fontFamily: "Customfont !important",
                        color: "black",
                        verticalAlign: "middle"
                    }}>{label}</InputLabel>
                </Tooltip>

                <TextField
                    sx={{
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                    }}
                    variant="standard"
                    hiddenLabel
                    id={"start" + id}
                    onChange={e => handleChange(e, "start")}
                    value={state.inputDataStart}
                    size="small"
                    type={inputType}
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e, "start")}
                    onKeyDown={handleKeyDown}
                    inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont" } }}


                />
                -
                {/* <Divider orientation="vertical" /> */}
                <TextField
                    sx={{
                        backgroundColor: "#fff",
                        fontFamily: "Customfont"
                    }}
                    hiddenLabel
                    id={"end" + id}
                    onChange={e => handleChange(e, "end")}
                    value={state.inputDataEnd}
                    variant="standard"
                    size="small"
                    type={inputType}
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e, "end")}
                    onKeyDown={handleKeyDown}
                    inputProps={{ style: { fontSize: "0.9rem", fontFamily: "Customfont" } }}
                />
                <CustomBackdrop open={openBackdrop} />
            </Paper>
        </Stack>
    );
}
CustominputRang.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    defaultValue: PropTypes.object,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string
}

